export default __webpack_public_path__ + "static/media/17-1.0f6be574.mp3";